<template>
    <div>
        <vue-easy-lightbox
            :visible="lightboxVisible"
            :move-disabled="true"
            :imgs="[lightboxUrl]"
            :index="0"
            @hide="lightboxVisible = false"
        />
        <form role="form">
        <div class="form-group row">
            <h5 class="col-md-4 text-md-right">{{ $t('orders.main-data') }}</h5>
        </div>
        <div class="form-group row" v-if="mode=='display' || mode=='edit'" key="orderNumberKey">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.order-number') }}</label>
            <div class="col-md-4">
                <input :disabled="true" type="email" class="form-control" name="number" v-model="form.number">
            </div>
        </div>

        <div class="form-group row" v-if="mode=='display' || mode == 'edit'" key="stateKey">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('orders.current-state') }}</label>
            <div class="col-md-4">
                <select
                    class="form-control"
                    name="state"
                    v-model="form.status"
                    :disabled="mode === 'display'"
                >
                    <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </select>

            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('service.form.description') }}</label>
            <div class="col-md-4">
                <input :disabled="this.formdisabled" type="email" class="form-control" name="desc" v-model="form.description" :placeholder="$t('service.form.description-placeholder')">
            </div>
        </div>

        <div class="additional-info">
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('service.form.note') }}</label>

                <div class="col-md-4">
                    <textarea :disabled="this.formdisabled" type="text" class="form-control" name="note" v-model="form.note" :placeholder="$t('service.form.note-placeholder')"></textarea>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Due on</label>
            <div class="col-md-1">
                <input
                    :disabled="this.formdisabled && mode === 'display'"
                    type="date"
                    class="form-control"
                    name="due_on"
                    v-model="form.due_on"
                >
            </div>
        </div>


            <!-- Checkbox um den Mietempfänger über den Auftrag zu informieren -->
        <div class="form-group row" v-if="this.mode == 'create' || this.mode == 'create-duplicated'">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('service.form.notify-service-worker-role') }}</label>
            <div class="col-md-6">
                <kendo-switch
                    v-model="form.recipient_create_contact_send_mail"
                    :messages="switchInternalMessages"
                    :on-label="this.$t('general.bool_true')"
                    :off-label="this.$t('general.bool_false')"
                    :width="'70'"
                    :disabled="this.formdisabled"
                ></kendo-switch>
            </div>
        </div>

          <div class="form-group row" v-if="mode == 'display'">
              <label class="col-md-4 col-form-label text-md-right">
                  {{ $t('service.form.attachments') }}
              </label>
              <div class="col-md-4">
                  <media-list :files="form.images || []" @image-click="openLightbox($event)" />
              </div>
          </div>

        <div class="form-group row" v-if="mode != 'display'">
            <label class="col-md-4 col-form-label text-md-right">{{ $t('service.form.attachments') }}</label>
            <div class="col-md-4">
                <service-uploads
                    :mode="mode"
                    :imageFiles="form.images"
                    @imageFilesChanged = "onImageFilesChanged"
                >
                </service-uploads>
            </div>
        </div>



        <div>
            <div class="form-group row">
                <h5 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.equipment') }}</h5>
            </div>
            <div class="form-group row" style="padding-bottom:25px;">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-7">
                    <object-picker-br
                        ref="objectpicker"
                        @objectAdd="onObjectAdd"
                        @objectRemove="onObjectRemove"
                        :availabilityDates="form.dates"
                        :mode="mode"
                        :orderid="this.orderid"
                        :pickType="'order'"
                        :formdisabled="formdisabled"
                        :presetobjects="form.rmsObjects"
                        :presetobjectid="presetobjectid"
                        :singleSelection="true"
                    >
                    </object-picker-br>
                </div>
            </div>

            <div class="service-logs" v-if="this.mode != 'create'">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">
                        {{ $t('service.form.logs') }}
                    </label>

                    <div class="col-md-4">
                        <div v-if="!orderid">
                            <em>{{ $t('general.not_available') }}</em>
                        </div>

                        <div v-else>
                            <div v-if="this.loading" class="text-muted">
                                {{ $t('general.loading') }}...
                            </div>

                            <div v-else>
                                <!-- Add-Button: immer sichtbar im Edit-Modus, unabhängig von Logs -->
                                <div class="d-flex justify-content-end mb-3" v-if="mode === 'edit'">
                                    <button type="button"
                                            class="btn btn-primary"
                                            @click="openLogWorkModal(orderid)">
                                        <i class="fas fa-plus mr-1"></i>
                                        {{ $t('service.grid.log-work') || 'Add log entry' }}
                                    </button>
                                </div>

                                <!-- Empty-State -->
                                <div v-if="!sortedServiceLogs.length"
                                     class="d-flex align-items-center p-3 rounded border mb-2 shadow-sm alert alert-light w-100"
                                     aria-live="polite">
                                    <span class="mr-2">{{ $t('general.no_data_found') }}</span>
                                    <!--<button v-if="mode === 'edit'"
                                            class="btn btn-outline-primary ml-auto"
                                            @click="openLogWorkModal(orderid)">
                                        <i class="fas fa-plus mr-1"></i>
                                        {{ $t('service.logs.add_first') || 'Add first log' }}
                                    </button>-->
                                </div>

                                <!-- Liste -->
                                <ul v-else class="list-unstyled">
                                    <li v-for="(log, idx) in sortedServiceLogs"
                                        :key="log.id"
                                        class="p-3 mb-3 rounded border shadow-sm bg-light">

                                        <!-- Header + Delete -->
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <div>
                                                <small class="text-muted d-block">
                                                    <strong>Entry created on:</strong> {{ formatDate(log.created_at) }}
                                                </small>
                                                <small class="text-muted d-block" v-if="log.started_at">
                                                    <strong>Worked on service order on:</strong> {{ formatDate(log.started_at) }}
                                                </small>
                                                <small class="text-muted d-block" v-if="log.time_spent">
                                                    <strong>Time-Spent:</strong> {{ formatTimeSpent(log.time_spent) }}
                                                </small>
                                                <small class="text-muted d-block" v-if="log.user">
                                                    <strong>Created by:</strong> {{ log.user.email }}
                                                </small>
                                            </div>

                                            <button v-if="mode == 'edit'"
                                                    type="button"
                                                    class="btn btn-outline-danger"
                                                    :disabled="deletingLogId === log.id"
                                                    @click="confirmDeleteServiceLog(log, idx)"
                                                    aria-label="Service-Log löschen">
                  <span v-if="deletingLogId === log.id"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                                                <span v-else>
                    <i class="fas fa-trash"></i>
                  </span>
                                            </button>
                                        </div>

                                        <!-- Beschreibung -->
                                        <div class="mt-1">
                                            <strong>Description of work:</strong>
                                            <span v-if="log.description && log.description.trim()">{{ log.description }}</span>
                                            <span v-else class="text-muted">{{ $t('general.no_description') || 'Keine Beschreibung' }}</span>
                                        </div>

                                        <!-- Attachments -->
                                        <div class="mt-2" v-if="log.media && log.media.length">
                                            <strong>Attachments:</strong>
                                            <media-list :files="log.media" @image-click="openLightbox($event)" />
                                        </div>
                                    </li>
                                </ul>

                                <!-- Modal -->
                                <form-log-work-modal
                                    v-if="showLogWorkModal"
                                    :serviceOrderId="selectedServiceOrderId"
                                    @close="showLogWorkModal = false"
                                    @servicelog-created="onServiceLogCreated" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </div>

        <div class="form-group row mb-0 pt-5">
            <div class="col-md-6 offset-md-4">
                <!--<button type="submit" class="btn btn-primary" v-if="mode == 'create'"
                        @click.prevent="createDraft">
                    Als Entwurf speichern
                </button>-->

                <button type="submit" class="btn btn-secondary" v-if="mode != 'display'"
                        @click.prevent="goBack">
                    {{ $t('buttons.back-abort') }}
                </button>
                <button type="submit" class="btn btn-secondary" v-if="mode == 'display'"
                        @click.prevent="goBack">
                    {{ $t('buttons.back-abort') }}
                </button>
                <button type="submit" class="btn btn-primary" v-if="mode == 'display'"
                        @click.prevent="editAction">
                    {{ $t('buttons.edit') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'create' || mode == 'create-duplicated'"
                        @click.prevent="createServiceOrder">
                    {{ $t('buttons.create') }}
                </button>
                <button type="submit" class="btn btn-success" v-if="mode == 'edit'"
                        @click.prevent="editServiceOrder">
                    {{ $t('buttons.save') }}
                </button>

            </div>
        </div>
    </form>
    </div>
</template>

<script>
import serviceUploads from "./service-uploads.vue";
import MediaList from './MediaList.vue';

import tagNoDataTemplate from "../rmsobjects/tag-nodata-template";
import ObjectPickerBr from "../orders/object-picker-br";
import {filterBy} from "@progress/kendo-data-query";
import {$t} from "../../i18Instance";
import rmsObjectsUploads from "../rmsobjects/rms-objects-uploads.vue";
import formLogWorkModal from "./form-log-work-modal.vue";
import VueEasyLightbox from 'vue-easy-lightbox'


var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
export default {
    name: "form-service",
    components: {
        serviceUploads,
        rmsObjectsUploads,
        ObjectPickerBr,
        MediaList,
        VueEasyLightbox,
        formLogWorkModal
    },
    props: {
        user: [String, Number],
        presetobjectid: [Number, Boolean],
        presetcustomerid: [Number, Boolean],
        orderid: [Number, Boolean],
        presetdata:[Object, Boolean],
        formdisabled: Boolean,
        mode: {
            type: String,
            default: 'create'
        },
        context:[String]
    },
    data: function () {
        return {
            showLogWorkModal: false,
            selectedServiceOrderId: null,
            reloadingLogs: false,
            deletingLogId: null,
            lightboxUrl: null,
            lightboxVisible: false,
            rightsCanCreateOrders: AshnetApp.can('orders create'),
            teamsData:[],
            tagDatasource: [],
            tagDatasourceUnfiltered: [],
            tagPickupRetPlaceDatasource: [],
            pickupMethodDatasource: [],
            returnMethodDatasource: [],

            loadedOrder: false,
            dateIsInPast: false,

            switchInternalMessages: {
                checked: this.$t('general.bool_true'),
                unchecked: this.$t('general.bool_false')
            },

            placeholders: {
                general_please_choose: {
                    name: this.$t('general.please_choose')
                },
                tagPickup: {
                    text: this.$t('orders.check-out-location-placeholder')
                },
                tagReturn: {
                    text: this.$t('orders.check-in-location-placeholder')
                }

            },

            loadedData: {},
            loading: false,
            customerData: 0,
            responsibilityData: 0,
            today: '',
            errors: {},
            statusOptions: [
                { value: 'open',              label: this.$t?.('service.status.open') || 'Open' },
                { value: 'in_progress',       label: this.$t?.('service.status.in_progress') || 'In Progress' },
                { value: 'waiting_for_parts', label: this.$t?.('service.status.waiting_for_parts') || 'Waiting for Parts' },
                { value: 'completed',         label: this.$t?.('service.status.completed') || 'Completed' },
            ],
            // Service-Logs
            serviceLogs: [],
            serviceLogsLoading: false,

            form:{
                attachments: [],
                comment: {
                    text: null
                },
                responsible_team_id: null,
                recipient_create_contact_send_mail: true,
                number: '',
                request_number:null,
                desc: '',
                tags:[],
                request_desc:'',
                request_equipment_select_type: 'specific',
                order_location: '',
                order_country: '',
                delivery_method_id: null,
                return_method_id: null,
                request_note: '',
                is_or_based_on_request: false,
                internal_use: false,
                exhibition_use: false,
                delivery_location: null,
                delivery_target_type: 'self',
                delivery_target_type_other: {},
                delivery_contact_send_mail: true,
                ret_location: null,
                return_target_type: 'self',
                return_target_type_other: {},
                return_by_receiver_target_type: 'returnToSender',
                return_by_receiver_target_type_other: {},
                return_contact_send_mail: true,
                from: new Date(),
                until: new Date(),
                dates:{
                    from: moment(),
                    until: moment()
                },
                rmsObjects: new Array(),
                customerId: this.presetcustomerid
            },
        }
    },
    computed: {
        // Absteigend nach created_at (fallback auf started_at), wie gewünscht
        sortedServiceLogs() {
            const logs = (this.loadedData && this.loadedData.service_logs) ? [...this.loadedData.service_logs] : []
            return logs.sort((a, b) => {
                const aKey = new Date(a.created_at || a.started_at || 0).getTime()
                const bKey = new Date(b.created_at || b.started_at || 0).getTime()
                return bKey - aKey
            })
        }
    },
    watch:{
    },
    mounted () {
        this.init();
    },
    methods: {
        openLogWorkModal(serviceOrderId) {
            this.selectedServiceOrderId = serviceOrderId
            this.showLogWorkModal = true
        },
        /**
         * Wird vom Modal gefeuert, wenn ein Log angelegt wurde.
         * Erwartetes Payload-Beispiel vom Modal:
         *   this.$emit('servicelog-created', {
         *     service_order_id: 123,
         *     log: { id, created_at, started_at, time_spent, description, user, media: [] }
         *   })
         */
        onServiceLogCreated({ serviceOrderId, log }) {
            this.showLogWorkModal = false

            Swal.fire({
                //target: document.getElementById('ash-modal-overlay'), // dein Modal-Wrapper
                icon: 'success',
                title: this.$t?.('servicelog.created-popup-title') || 'Log entry saved!',
                text: this.$t?.('servicelog.created-popup-text') || 'The service log was successfully created.',
                timer: 1500,
                showConfirmButton: false,
            })

            if (!this.loadedData) this.loadedData = {}
            if (!Array.isArray(this.loadedData.service_logs)) this.loadedData.service_logs = []

            if (log?.id) {
                // Duplikate verhindern (falls Event doppelt)
                const i = this.loadedData.service_logs.findIndex(l => String(l.id) === String(log.id))
                if (i !== -1) this.loadedData.service_logs.splice(i, 1)

                // oben einfügen
                this.loadedData.service_logs.unshift(log)
            } else {
                // Fallback: wenn API unerwartet nichts liefert, full reload
                console.warn('onServiceLogCreated: no log ID received');
                this.reloadServiceLogs(serviceOrderId)
            }
        },

        async reloadServiceLogs(serviceOrderId) {
            try {
                this.reloadingLogs = true
                // Beispiel-Call: passe URL/Controller an dein Backend an
                const { data } = await axios.get(`/api/service-orders/${serviceOrderId}`)
                // Erwartet, dass data.data.service_logs existiert (API Resource)
                const serviceOrder = data && (data.data || data)
                if (serviceOrder && Array.isArray(serviceOrder.service_logs)) {
                    this.$set(this.loadedData, 'service_logs', serviceOrder.service_logs)
                }
            } catch (e) {
                console.error('Failed to reload service logs', e)
                this.$bvToast && this.$bvToast.toast(this.$t('general.reload_failed') || 'Reload failed', { variant: 'danger' })
            } finally {
                this.reloadingLogs = false
            }
        },


        onImageFilesChanged(changedMedia){
            console.log("onImageFilesChanged", changedMedia);
            this.form.imageFiles = changedMedia;
        },
        formatDate(dateIn) {
            if(dateIn){
                //return moment(dateIn).format(AshnetApp.dateTimeFormat + " - HH:mm");
                return moment(dateIn).format(AshnetApp.dateTimeFormat);
            }
            return '';
        },

        formatTimeSpent(minutes) {
            if (!minutes && minutes !== 0) return '-';
            if (minutes < 60) {
                return `${minutes} ${this.$t('general.minutes') || 'minutes'}`;
            }
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            if (m === 0) {
                return `${h} ${this.$t('general.hours') || 'hours'}`;
            }
            return `${h} ${this.$t('general.hours') || 'hours'} ${m} ${this.$t('general.minutes') || 'minutes'}`;
        },


        init: function(){
            console.log("form-service init... ", this.orderid, this.mode, this.context, this.formdisabled);

            if(this.mode == 'create'){
                this.form.dates.from = moment();
                this.form.dates.until = moment().add(1,'days');

                this.form.from = moment();
                this.form.until = moment().add(1,'days');
            }

            // Prüfen ob der gewählte Zeitraum ganz oder teilweise in der Vergangenheit ist
            if(this.form.from < moment().startOf('day') || this.form.until < moment().startOf('day') ){
                this.dateIsInPast = true;
            }else {
                this.dateIsInPast = false;
            }

            console.log("lade Verfügbarkeit der Verleihobjekte neu");
            // Nur den Object Picker neu laden, wenn auch direkt equipment gewählt werden soll
            if(this.form.request_equipment_select_type =='specific')
                this.$refs.objectpicker.reloadStore();


            // Laden eines bestehenden Auftrags
            if(this.orderid){
                this.loading = true;
                axios
                    .get('/api/service-orders/' + this.orderid)
                    .then(response => {
                        console.log("existing order / request loaded")
                        this.loadedData = response.data;
                        this.prepareEditData();
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log("err", error);
                        this.loading = false;
                    })
            }
        },

        prepareData(){

        },

        /**
         * Bereitet die geladenen Daten für die Edit-Maske vor
         */
        prepareEditData: function() {
            console.log("loaded ORder vor setzen", this.loadedData);
            // Formulardaten setzen

            //this.form = this.loadedData;

            this.form = this.loadedData;

            this.form.due_on = (this.loadedData.due_on || '').substring(0, 10)

            this.form.id = this.loadedData.id;
            this.form.number = this.loadedData.number;
            this.form.request_number = this.loadedData.request_number;
            this.form.is_or_based_on_request = this.loadedData.is_or_based_on_request;
            this.form.stateText = this.loadedData.stateText;
            this.form.responsible_team_id = this.loadedData.responsible_team_id;
            this.form.internal_use = this.loadedData.internal_use;
            this.form.exhibition_use = this.loadedData.exhibition_use;
            this.form.responsibility_id = this.loadedData.responsibility_id;

            if(this.loadedData.customer != null) this.form.customerId = this.loadedData.customer.id;

            this.form.desc = this.loadedData.desc;
            this.form.order_location = this.loadedData.order_location;
            this.form.order_country = this.loadedData.order_country;
            this.form.tags = this.loadedData.attachedTags;

            this.form.from = moment(this.loadedData.from);
            this.form.until = moment(this.loadedData.until);
            /*
            this.form.dates.from = moment(this.loadedData.from);
            this.form.dates.until = moment(this.loadedData.until);
             */

            // Tatsächliche Herausgabe und Rücknahme
            if(this.loadedData.checkout_at)
                this.form.checkout_at = moment(this.loadedData.checkout_at).format(AshnetApp.dateTimeFormat);

            if(this.loadedData.checkin_at)
                this.form.checkin_at = moment(this.loadedData.checkin_at).format(AshnetApp.dateTimeFormat);

            // Herausgabe
            this.form.delivery_location = this.loadedData.delivery_location;
            this.form.delivery_method_id = this.loadedData.delivery_method_id;
            this.form.delivery_target_type = this.loadedData.delivery_target_type;


            // Rücknahme
            this.form.ret_location = this.loadedData.return_location;
            this.form.return_method_id = this.loadedData.return_method_id;
            this.form.return_target_type = this.loadedData.return_target_type;
            this.form.return_by_receiver_target_type = this.loadedData.return_by_receiver_target_type;

            // Antrag
            this.form.approval_status = this.loadedData.approval_status;

            // Immer als Array normalisieren (einzelnes Objekt -> [Objekt], nichts -> [])
            const rms = this.loadedData.rmsObject;
            console.log("rms", rms);
            this.form.rmsObjects = Array.isArray(rms) ? rms : (rms ? [rms] : []);

            this.form.request_note = this.loadedData.request_note;
            this.form.comments = this.loadedData.comments;



            this.form.images =this.loadedData.images;
            console.log("form.images", this.form.images);


            console.log("currForm yeah", this.form);
        },


        onObjectAdd: function(addedObject) {
            this.form.rmsObjects.push(addedObject);
        },

        onObjectRemove: function(removedObject) {
            this.form.rmsObjects = this.form.rmsObjects.filter(function( obj ) {
                return obj.id !== removedObject.id;
            });
        },


        applyOtherReturnAddressFromOtherDeliveryAddress: function(){
            // Kann nicht einfach zugewiesen werden, da sonst gleiche Referenz und Reactivity
            this.form.return_target_type_other = JSON.parse(JSON.stringify(this.form.delivery_target_type_other));
        },

        resetOtherReturnAddress: function(){
            this.form.return_target_type_other = {};
        },

        /**
         * Öffnet dieses Fenster
         */
        showWindow(){
            this.today = new Date();
            var window = this.$refs.createWindow.kendoWidget();
            window.center().open();
        },

        /**
         * Schließt dieses Fenster
         */
        hideWindow(){
            var window = this.$refs.createWindow.kendoWidget();
            window.close();
        },

        resetForm(){
            this.form = {};
        },

        onWindowActivated(){
            this.$refs.firstInput.focus();
        },

        onWindowClosed(){
            this.resetForm();
        },

        saveComment(){
            this.sendForm('post','/api/orders/storecomment/'+this.form.id, this.form)
                .then(() => {
                    console.log("comment saved");
                    this.init();
                });
        },

        /**
         * Sendet die Formulardaten zum Server und versucht den Auftrag anzulegen
         */
        createServiceOrder() {
            console.log("createServiceOrder");
            this.prepareData();
            console.log(this.form);
            // Daten senden
            this.sendForm('post','/api/service-orders', this.form)
                .then(() => {
                    //this.$emit('order-created');
                    this.onOrderCreated();
                });
        },

        editServiceOrder(){
            console.log("editServiceOrder");
            this.prepareData();
            console.log(this.orderid);
            console.log(this.form);
            // Daten senden
            this.sendForm('put','/api/service-orders/'+this.orderid, this.form)
                .then(() => {
                    this.onOrderUpdated();
                    //this.$emit('order-updated');
                },()=>{
                    this.onOrderUpdateFailed();
                    //this.$emit('order-update-failed');
                });
        },


        async confirmDeleteServiceLog(log, idx) {
            try {
                const result = await swal.fire({
                    title: this.$t?.('servicelog.grid.delete-popup-title'),
                    text: this.$t?.('servicelog.grid.delete-popup-text'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t?.('general.ok') || 'Löschen',
                    cancelButtonText: this.$t?.('general.cancel') || 'Abbrechen',
                    reverseButtons: false,
                });
                if (!result.isConfirmed) return;

                this.deletingLogId = log.id;
                await axios.delete(`/api/service-logs/${log.id}`);

                // Eintrag lokal entfernen
                if (Array.isArray(this.loadedData?.['service_logs'])) {
                    this.loadedData['service_logs'].splice(idx, 1);
                }

                await swal.fire({
                    icon: 'success',
                    title: this.$t?.('servicelog.grid.delete-popup-deleted'),
                    timer: 1200,
                    showConfirmButton: false,
                });
            } catch (e) {
                const msg = e?.response?.data?.message || e?.message || 'Löschen fehlgeschlagen.';
                swal.fire({
                    icon: 'error',
                    title: this.$t?.('general.error') || 'Fehler',
                    text: msg,
                });
            } finally {
                this.deletingLogId = null;
            }
        },

            editAction: function () {
            console.log("edit action", this.orderid);
            this.$router.push({ name: 'service-order-edit', params: {
                    orderid: this.orderid,
                    mode: 'edit',
                    context: this.context
                }});
        },



        goBack(){
            if(this.context != ""){
                this.handleBack(this.context, false, {reload: false, id: this.form.id});
            }else{
                this.handleBack('orders-grid', false, {reload: false, id: this.form.id});
            }
        },

        sendForm(method, uri, form){
            console.log("in sendForm");
            return new Promise((resolve, reject) => {
                axios[method](uri, form)
                    .then(response => {
                        console.log("response from sendform", response.data);
                        resolve(response.data);
                    })
                    .catch(errors => {
                        reject(errors.response.data);
                    });
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Auftrag angelegt wurde
         */
        onOrderCreated:function(){
            console.log("onOrderCreated");
            swal.fire({
                title: $t('orders.creationSuccess.title'),
                text: $t('orders.creationSuccess.text'),
                icon: "success",
                timer: 1000
            }).then(() => {
                if(this.context != undefined && this.context != ""){
                    this.handleBack(this.context, true, {reload: true, id: this.form.id});
                }else{
                    this.handleBack('service-grid', true, {reload: true, id: this.form.id});
                }
            });
        },

        onOrderUpdated:function(){
            swal.fire({
                title: $t('orders.updateSuccess.title'),
                text: $t('orders.updateSuccess.text'),
                icon: "success",
                timer: 1000
            }).then(() => {
                if(this.context != undefined && this.context != ""){
                    this.handleBack(this.context, true, {reload: true, id: this.form.id});
                }else{
                    this.handleBack('service-grid', true, {reload: true, id: this.form.id});
                }

                //window.location.href = '/orders';
            });
        },

        onOrderUpdateFailed:function(){
            swal.fire({
                title: $t('orders.updateFailure.title'),
                text: $t('orders.updateFailure.text'),
                icon: "error",
            }).then(() => {
                if(this.context != ""){
                    this.handleBack(this.context, true, {reload: true, id: this.form.id});
                }else{
                    this.handleBack('orders-grid', true, {reload: true, id: this.form.id});
                }
            });
        },
        openLightbox(url) {
            console.log("openLightbox", url);
            this.lightboxUrl = url;
            this.lightboxVisible = true;
        }




    }
}
</script>

<style scoped>
.objPicker{
    height:500px!important;
}
.descriptionPaddingTop{
    padding-top:40px;
}
.comment-text {
    white-space: pre-wrap; /* Behält Zeilenumbrüche bei */
}

</style>
